import { getAvailableProductsArray } from "library/hubspot/get-products.mjs"

/**
 * The demands an override may confer, and which product each comes from (FIQ-1926).
 *
 * Derived client-side from the same catalogue the server validates against — no extra endpoint
 * needed, and the picker cannot offer something the server would reject. The grouping is what
 * makes cherry-picking usable: you find scheduleEditor under FIQT3 and take just that.
 *
 * This is why the allowlist is "anything a product grants": it structurally cannot offer
 * `admin`, because no product grants it.
 */
export function getGrantableDemandOptions() {
    const byDemand = new Map()

    for (const product of getAvailableProductsArray()) {
        for (const demand of product.demands ?? []) {
            if (!byDemand.has(demand)) byDemand.set(demand, { demand, products: [] })
            byDemand.get(demand).products.push(product.sku)
        }
    }

    return [...byDemand.values()]
        .map((option) => ({ ...option, group: option.products.join(", ") }))
        .sort((a, b) => a.demand.localeCompare(b.demand))
}

export function findDemandOption(demand) {
    return getGrantableDemandOptions().find((option) => option.demand === demand)
}
